// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3aziW","location":"Header_location__I0XBa"};